import axios from "axios";
import { saveAs } from "file-saver";
import { apiVariable } from "./apiVariable";

export type TimeOffDocumentType = "ordin" | "cerere";

const documentLabels: Record<TimeOffDocumentType, string> = {
  ordin: "Ordin",
  cerere: "Cerere",
};

const getResponseFileName = (
  contentDisposition: string | undefined,
  fallback: string,
) => {
  const utf8FileName = contentDisposition?.match(
    /filename\*=UTF-8''([^;]+)/i,
  )?.[1];

  if (utf8FileName) {
    try {
      return decodeURIComponent(utf8FileName.replace(/^"|"$/g, ""));
    } catch {
      return utf8FileName.replace(/^"|"$/g, "");
    }
  }

  const fileName = contentDisposition?.match(/filename="?([^";]+)"?/i)?.[1];
  return fileName || fallback;
};

export const generateTimeOffDocument = async (
  requestId: string,
  documentType: TimeOffDocumentType,
  token: string,
) => {
  const response = await axios.get<Blob>(
    `${apiVariable}/timeOffRequests/${requestId}/documents/${documentType}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "blob",
    },
  );

  const fallbackFileName = `${documentLabels[documentType]}_${requestId}.docx`;
  const fileName = getResponseFileName(
    response.headers["content-disposition"],
    fallbackFileName,
  );

  saveAs(response.data, fileName);
};

export const getTimeOffDocumentErrorMessage = async (
  error: unknown,
  fallback: string,
) => {
  if (!axios.isAxiosError(error)) return fallback;

  const responseData = error.response?.data;

  if (responseData instanceof Blob) {
    const text = await responseData.text();
    if (!text) return fallback;

    try {
      const parsed = JSON.parse(text);
      return parsed.message || parsed.title || text;
    } catch {
      return text;
    }
  }

  if (typeof responseData === "string" && responseData.trim()) {
    return responseData;
  }

  if (responseData && typeof responseData === "object") {
    const data = responseData as { message?: string; title?: string };
    return data.message || data.title || fallback;
  }

  return fallback;
};
